import { createInfoTooltipAddon, type OptionLabelPair } from '../../../../components/RadioGroup';
import type { BooleanFlag } from '../../../../types/boolean-flag';
import { BOOLEAN_FLAGS } from '../../../../types/boolean-flag';
import type { SyncDirection } from '../../../../stripe-components/configure-stripe-integration/StripeConfigurationFormSchema';
import { SYNC_DIRECTIONS } from '../../XeroConfigurationFormSchema';
import {
  INVOICE_NUMBER_SYNC_STRATEGY,
  INVOICE_PAYMENT_STATUS_SYNC_STRATEGY,
  TAX_EXPORT_STRATEGY,
  type InvoiceNumberSyncStrategy,
  type InvoicePaymentStatusSyncStrategy,
  type TaxExportStrategy,
} from '@vy/integrations-types';

export const AUTOMATICALLY_SYNC_INVOICES_OPTIONS: OptionLabelPair<BooleanFlag>[] = [
  { value: BOOLEAN_FLAGS.ENABLED, label: 'Automatically sync invoices upon approval (recommended)' },
  { value: BOOLEAN_FLAGS.DISABLED, label: 'Do not sync automatically' },
];

export const SYNC_CUSTOMERS_OPTIONS: OptionLabelPair<SyncDirection>[] = [
  { value: SYNC_DIRECTIONS.SYNC_TO_VAYU, label: 'Sync customers from Xero to Vayu' },
  { value: SYNC_DIRECTIONS.SYNC_FROM_VAYU, label: 'Sync customers from Vayu to Xero' },
  { value: SYNC_DIRECTIONS.AUTO_SYNC_DISABLED, label: 'Do not sync automatically' },
];

export const INVOICE_NUMBER_SYNC_STRATEGY_OPTIONS: OptionLabelPair<InvoiceNumberSyncStrategy>[] = [
  {
    value: INVOICE_NUMBER_SYNC_STRATEGY.KEEP_SEPARATE,
    label: 'Keep Invoice Numbers Separate between Xero & Vayu',
  },
  {
    value: INVOICE_NUMBER_SYNC_STRATEGY.VAYU_TO_ERP,
    label: 'Generate invoice numbers in Vayu and sync to Xero',
    renderAddon: createInfoTooltipAddon(
      'To use Vayu invoice numbers in Xero, invoice numbers will be synced when exporting invoices.',
      '',
    ),
  },
  {
    value: INVOICE_NUMBER_SYNC_STRATEGY.ERP_TO_VAYU,
    label: 'Use Xero invoice numbers and override Vayu numbers',
  },
];

export const INVOICE_PAYMENT_STATUS_SYNC_STRATEGY_OPTIONS: OptionLabelPair<InvoicePaymentStatusSyncStrategy>[] = [
  {
    value: INVOICE_PAYMENT_STATUS_SYNC_STRATEGY.KEEP_SEPARATE,
    label: "Don't sync invoices billing status with 3rd parties",
  },
  {
    value: INVOICE_PAYMENT_STATUS_SYNC_STRATEGY.ERP_TO_VAYU,
    label: 'Use Xero as the source of truth for invoice status in Vayu',
  },
  {
    value: INVOICE_PAYMENT_STATUS_SYNC_STRATEGY.VAYU_TO_ERP,
    label: 'Manage invoice payments and status in Vayu (synced to Xero)',
  },
];

export const AUTOMATICALLY_SYNC_CREDIT_MEMOS_OPTIONS: OptionLabelPair<BooleanFlag>[] = [
  {
    value: BOOLEAN_FLAGS.ENABLED,
    label: 'Automatically sync credit memo upon credit ledger creation',
  },
  { value: BOOLEAN_FLAGS.DISABLED, label: 'Do not sync automatically' },
];

export const TAX_EXPORT_STRATEGY_OPTIONS: OptionLabelPair<TaxExportStrategy>[] = [
  { value: TAX_EXPORT_STRATEGY.INCLUDE_IN_AMOUNT, label: 'Include tax in line item amounts' },
  { value: TAX_EXPORT_STRATEGY.SEPARATE_LINE_ITEM, label: 'Export tax as a separate line item' },
  {
    value: TAX_EXPORT_STRATEGY.EXCLUDE_TAX,
    label: 'Mark line items as taxable',
  },
];
